const { ActionTypes } = require("../constants/action_types");

const initialState = null;

export const fhirMetaDataReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.FHIR_META_DATA:
            return state = payload; 
        default:
            return state;
    }
};